import { render, staticRenderFns } from "./TooltipSchutz.vue?vue&type=template&id=8dcf0336&scoped=true&"
import script from "./TooltipSchutz.vue?vue&type=script&lang=js&"
export * from "./TooltipSchutz.vue?vue&type=script&lang=js&"
import style0 from "./TooltipSchutz.vue?vue&type=style&index=0&id=8dcf0336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcf0336",
  null
  
)

export default component.exports